import * as THREE from "three";
import { Dexie } from "dexie";

export class Database {
  constructor() {
    this.db = this.initializeDatabase();
    this.loader = new THREE.ObjectLoader();
  }

  initializeDatabase() {
    const database = new Dexie("HyperboardDatabase");
    database.version(1).stores({
      cubes: "id",
      tubes: "id, firstObjectUuid, secondObjectUuid",
    });
    return database;
  }

  saveTube(tube) {
    const firstObject = tube.userData.firstObject;
    const secondObject = tube.userData.secondObject;
    this.db.tubes.put({
      id: tube.uuid,
      firstObject: { name: firstObject.name, uuid: firstObject.uuid },
      secondObject: { name: secondObject.name, uuid: secondObject.uuid },
      firstObjectUuid: firstObject.uuid,
      secondObjectUuid: secondObject.uuid,
      animations: tube.userData.animations,
    });
  }

  async deleteTubes(cubeUuid) {
    const matchingTubes = await this.db.tubes
      .where("firstObjectUuid")
      .equals(cubeUuid)
      .or("secondObjectUuid")
      .equals(cubeUuid)
      .toArray();

    const tubeIds = matchingTubes.map((tube) => tube.id);
    await this.db.tubes.bulkDelete(tubeIds);
  }

  async deleteCube(cube) {
    await this.deleteTubes(cube.uuid);
    await this.db.cubes.delete(cube.uuid);
  }

  saveCube(object) {
    const label = object.getObjectByName("label");
    const sides = [];
    object.children.forEach((child) => {
      if (["front", "back", "left", "right", "top"].includes(child.name)) {
        sides.push({
          name: child.name,
          value: child.text,
          fontSize: child.fontSize,
        });
      }
    });
    const cube = {
      id: object.uuid,
      name: object.name,
      color: object.userData.color,
      labelText: label.element.textContent,
      position: object.position.toArray(),
      rotation: object.rotation.toArray(),
      scale: object.scale.toArray(),
      sides: sides,
    };
    this.db.cubes.put(cube);
  }

  async getAllCubes() {
    try {
      return await this.db.cubes.toArray();
    } catch (error) {
      console.error("Error loading cubes from database:", error);
      return [];
    }
  }

  async getAllTubes() {
    try {
      return await this.db.tubes.toArray();
    } catch (error) {
      console.error("Error loading tubes from database:", error);
      return [];
    }
  }

  async getCubeById(id) {
    try {
      return await this.db.cubes.get(id);
    } catch (error) {
      console.error(`Error loading cube with id ${id} from database:`, error);
      return undefined;
    }
  }

  async getTubeById(id) {
    try {
      return await this.db.tubes.get(id);
    } catch (error) {
      console.error(`Error loading tube with id ${id} from database:`, error);
      return undefined;
    }
  }
}
